import React from "react";

export default function IndexSection({ className, ...props }) {
  return <div className={`m-auto max-w-screen-xl flex-grow w-full ${className}`} {...props} />;
}
